__turbopack_context__.v({
  "className": "bebas_neue_bd2a2a3f-module__mHUiMq__className",
  "variable": "bebas_neue_bd2a2a3f-module__mHUiMq__variable",
});
